import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { LIVE_ACTIVITY, purchaseEvents } from '../data/liveActivity';
import { IMAGES, PRICE } from '../data/offer';
import { CartIcon, VerifiedIcon, XIcon } from './icons/CraftIcons';
export function LivePurchaseToast() {
  // Even steps are the quiet gap, odd steps show a notification.
  const [step, setStep] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  const visible = step % 2 === 1;
  const event = purchaseEvents[Math.floor(step / 2) % purchaseEvents.length];
  useEffect(() => {
    if (dismissed) return;
    const delay = step === 0 ? LIVE_ACTIVITY.firstDelayMs : visible ? LIVE_ACTIVITY.visibleMs : LIVE_ACTIVITY.hiddenMs;
    const id = window.setTimeout(() => setStep(current => current + 1), delay);
    return () => window.clearTimeout(id);
  }, [step, visible, dismissed]);
  if (dismissed) return null;
  return <div className="pointer-events-none fixed bottom-4 left-3 right-3 z-40 sm:bottom-5 sm:left-5 sm:right-auto sm:max-w-[350px]" aria-live="polite" aria-atomic="true" data-id="element-251" data-mp="3pns0967b658c">
      <AnimatePresence data-id="element-252" data-mp="3uopghd8rcp77">
        {visible ? <motion.div key={event.id} initial={{
        opacity: 0,
        x: -24,
        y: 10,
        scale: 0.96
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        x: -20,
        scale: 0.96
      }} transition={{
        type: 'spring',
        stiffness: 260,
        damping: 24
      }} className="pointer-events-auto flex items-center gap-3 rounded-2xl border border-hairline bg-ivory p-2.5 shadow-lift" data-id="element-253" data-mp="3guf1hnmkc9ec">
            <div className="h-14 w-14 shrink-0 overflow-hidden rounded-xl border border-hairline bg-linen" data-id="element-254" data-mp="2xyotnjry8isj">
              <img src={IMAGES.treasuryBook} alt="" className="h-full w-full object-cover" loading="lazy" decoding="async" data-id="element-255" data-mp="3200mrza17m5h" />
            </div>

            <div className="min-w-0 flex-1" data-id="element-256" data-mp="2941717xtr73v">
              <p className="flex items-center gap-1.5 text-[12.5px] font-extrabold text-ink" data-id="element-257" data-mp="291oiud1h40id">
                {event.name}
                <VerifiedIcon className="h-3.5 w-3.5 shrink-0 text-sage" data-id="element-258" data-mp="2032z4ek9mfg0" />
              </p>
              <p className="text-[11.5px] leading-snug text-ink-soft" data-id="element-259" data-mp="1v3zwt1vo6nbq">
                in {event.city} just unlocked the {'\u0024'}
                {PRICE.today} Treasury
              </p>
              <p className="mt-0.5 flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-wide text-sage-dark" data-id="element-260" data-mp="2rw3i83rp5v6q">
                <CartIcon className="h-3 w-3" data-id="element-261" data-mp="2j1p1dwriqcli" />
                {event.minutesAgo} min ago
              </p>
            </div>

            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss purchase notifications" className="shrink-0 self-start rounded-full p-1 text-ink-faint transition-colors hover:bg-linen hover:text-ink" data-id="element-262" data-mp="2e1t1o9put7br">
              <XIcon className="h-3.5 w-3.5" data-id="element-263" data-mp="3e3pqp2ul7sui" />
            </button>
          </motion.div> : null}
      </AnimatePresence>
    </div>;
}